module.exports = __webpack_public_path__ + "static/hero-bc1ed46b42bd5151a72929386b4e1387.jpg";